import dayjs from "dayjs";

export function formatDate(value, dateFormat, timeFormat = null, timeZone = null) {
    if (!value) {
        return '';
    }

    let format = 'DD-MM-YYYY';

    if (dateFormat === 'm-d-Y') {
        format = 'MM-DD-YYYY';
    } else if (dateFormat === 'Y-m-d') {
        format = 'YYYY-MM-DD';
    }

    if (timeFormat) {
        format += ' ' + timeFormat;
    }

    let date = dayjs.utc(value);

    if (timeZone) {
        date = date.tz(timeZone);
    }

    return date.format(format);
}
